import { all, takeEvery, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import {
    LoginAndRegisterActionType,
    RegisterUser,
    ResendConfirmationCode,
    setUserEmail,
    SetUserEmail,
    VerifyEmail,
} from '../../actions/loginAndRegisterActions';
import { RequestActionType, requestError, requestSuccess } from '../../actions/requestActions';
import fetchRegister, { resendVerificationCode, verifyEmail } from '../../api/register';
import RequestActions from '../../models/RequestTypes';
import { RequestType } from '../../reducers/requestReducer';
import { toErrorType } from '../isErrorType';
import { redirectWithQuery } from './loginSaga';

type RegisterSaga = Generator<CallEffect<void> | PutEffect<SetUserEmail> | RequestActions, void, void>;

export function* registerSaga({ payload }: RegisterUser): RegisterSaga {
    try {
        yield call(fetchRegister, payload);
        yield put(setUserEmail(payload.email));
        yield put(requestSuccess(RequestType.RegisterUser, RequestActionType.Success));
        redirectWithQuery('/verify');
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.RegisterUser, RequestActionType.Error));
    }
}

type ResendVerificationCodeSaga = Generator<
    CallEffect<undefined | Promise<string>> | CallEffect<void> | PutEffect<SetUserEmail> | RequestActions,
    void,
    string
>;

export function* resendVerificationCodeSaga({ email }: ResendConfirmationCode): ResendVerificationCodeSaga {
    try {
        yield call(resendVerificationCode, { email });
        yield put(setUserEmail(email));
        yield put(requestSuccess(RequestType.ResentConfirmationCode, RequestActionType.Success));
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.ResentConfirmationCode, RequestActionType.Error));
    }
}

type VerifyEmailSaga = Generator<
    CallEffect<undefined | Promise<string>> | CallEffect<void> | RequestActions,
    void,
    string
>;
export function* verifyEmailSaga(payload: VerifyEmail): VerifyEmailSaga {
    try {
        yield call(verifyEmail, payload);
        yield put(requestSuccess(RequestType.VerifyEmail, RequestActionType.Success));
        redirectWithQuery('/login');
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.VerifyEmail, RequestActionType.Error));
    }
}

export default function* (): Generator {
    yield all([
        takeEvery(LoginAndRegisterActionType.RegisterUserInit, registerSaga),
        takeEvery(LoginAndRegisterActionType.ResentConfirmationCodeInit, resendVerificationCodeSaga),
        takeEvery(LoginAndRegisterActionType.VerifyEmailInit, verifyEmailSaga),
    ]);
}
